export type SortOption =
  'recent' | 'oldest' | 'largest' | 'smallest' | 'user_asc' | 'user_desc';

export const getSortOptions = () => [
  { value: 'recent', label: 'Most Recent' },
  { value: 'oldest', label: 'Oldest First' },
  { value: 'largest', label: 'Largest File' },
  { value: 'smallest', label: 'Smallest File' },
];

export const getStatusOptions = () => [
  { value: 'all', label: 'All Status' },
  { value: 'approved', label: 'Approved' },
  { value: 'pending', label: 'Pending' },
  { value: 'rejected', label: 'Rejected' },
];

export const getExtensionStatusOptions = () => [
  { value: 'all', label: 'All Status' },
  { value: 'pending', label: 'Pending Review' },
  { value: 'approved', label: 'Approved' },
  { value: 'processing', label: 'Processing' },
  { value: 'completed', label: 'Completed' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'failed', label: 'Failed' },
];
